import _ from 'lodash';

export default function Enum<T extends string>(
  ...args: Array<T | Array<T>>
): {[index: string]: T} {
  const pairs = _.flattenDeep(args)
    .map(String)
    .map((x) => [x, x]);

  const output = _.fromPairs(pairs);
  Object.freeze(output);

  return output;
}
